import { designationList } from "constants/designation";
import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

export const getDesignationList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.designation_list(pageNum, filters);
    dispatch({ type: designationList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: designationList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error.response?.data);
  }
};